import apiHelper from "services/apiHelper";
import useSWR from "swr";

export const getSingleProduct = (id) => {
    return apiHelper(`api/v1/product/get_single_product/${id}`, "get", null, {});
  };

  export function getFilteredProducts(payload) {
    return apiHelper(`api/v1/product/get_filtered_products`, "post", payload, {});
  }

export const saveProduct = (payload, id) => {
    return id
      ? apiHelper(`api/v1/product/update_product/${id}`, "patch", payload, {})
      : apiHelper(`api/v1/product/create_product`, "post", payload, {});
  };

  export function getPaginatedProductsAPI({ params }) {
    return apiHelper(`api/v1/product/get_admin_products?${params.query}`, "get", null, {});
  }
  
  const getProductsFetcher = async ({ url, ...params }) => {
    const searchData = await getPaginatedProductsAPI({
      params,
    });
  
    return searchData.data.data;
  };
  
  const usePaginatedProducts = (params) => {
    return useSWR(
      params
        ? {
            url: `/api/products`,
            ...params,
          }
        : null,
      getProductsFetcher,
      {
        revalidateOnFocus: false,
        dedupingInterval: 3000,
        errorRetryCount: 3,
      }
    );
  };
  
export default usePaginatedProducts;
